import { configureStore } from "@reduxjs/toolkit";
import { loadState, saveState } from "../utility/LocalStorage";
import reducer from "./reducers/Reducers";
import {thunk} from "redux-thunk";

const persistedState = loadState();

const rootReducer = {
  root: reducer,
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});

store.subscribe(() => {
  saveState(store.getState());
});

export default store;
